<template>
  <div class="setup-account">
    <div class="security-question">
      <p style="font-size: 20px; text-align:left;" v-if="!expired && !broken">Welcome, <strong>{{ firstname }}</strong>
      </p>
      <div class="setup">
        <div v-if="(!expired && !broken) && !success">
          <h3>Change password</h3>
          <p class="text-left">Please set your password to continue your account set up process</p>
          <form class="form" @keypress="send" @submit.prevent>
            <div>
              <label>New Password</label>
              <input type="password" v-model="new_password" placeholder="New Password">
              <span class="error" v-if="error.new_password">*Required</span>
              <span class="error" v-if="error.new_password_length">*Require mimium of 8 characters</span>
            </div>
            <div style="margin-top:1em">
              <label>Confirm New Password</label>
              <input type="password" v-model="confirm_new_password" placeholder="Confirm New Password">
              <span class="error" v-if="error.confirm_new_password">*Required</span>
              <span class="error" v-if="error.confirm_new_password_length">*Require mimium of 8 characters</span>
              <span class="error" v-if="error.confirm_new_password_mismatch">Confirm password mismatch new password</span>
            </div>
            <div class="submit">
              <button type="button" @click="submit">Continue</button>
            </div>
          </form>
        </div>
        <div v-if="success" class="expired">
          <p>
            <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
          </p>
          <p>Password changed success.<br /> Please click on the login link below to continue</p>
          <p>
            <router-link to="/login">Login</router-link>
          </p>
        </div>
        <div v-if="expired && !broken" class="expired">
          <p>
            <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
          </p>
          <p>Sorry, link is expired</p>
          <p>
            <router-link to="/login">Login</router-link>
          </p>
        </div>
        <div v-if="!expired && broken" class="broken">
          <p>
            <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
          </p>
          <p>Sorry, link is broken or doesn't exist</p>
          <p>
            <router-link to="/login">Login</router-link>
          </p>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
    <notify ref="notify"></notify>
  </div>
</template>
<style scoped>
.expired {
  width: 400px;
}

.expired p {
  font-size: 14px;
  margin-bottom: 0;
}

.broken {
  width: 400px;
}

.broken p {
  font-size: 14px;
  margin-bottom: 0;
}

.security-question .setup .form div {
  margin-bottom: 0;
}

.setup-account {
  height: 100%;
}

.security-question {
  height: 100%;
}

.question {
  margin-bottom: 1em !important;
}

.question label {
  font-weight: normal !important;
  margin-bottom: 0 !important;
}
</style>

<script>
import loading from '@/components/Loading'
import notify from '@/components/Notify'
import AuthenticationService from '../services/AuthenticationService'
export default {
  components: {
    loading,
    notify
  },
  data() {
    return {
      question: '',
      lastname: '',
      firstname: '',
      answer: '',
      broken: false,
      expired: false,
      success: false,
      error: {
        password: false,
        con_password: false,
        password_length: false,
        con_password_length: false,
        current_password: false,
        new_password: false,
        confirm_new_password: false,
        confirm_new_password_mismatch: false,
        confirm_new_password_length: false,
        new_password_length: false,
        current_password_error: false
      },
      new_password: '',
      confirm_new_password: ''
    }
  },
  methods: {
    send(evt) {
      if (evt.keyCode === 13) {
        this.post = true
        this.error.current_password_error = false

        if (this.new_password === '') {
          this.error.new_password = true
          this.post = false
        } else {
          this.error.new_password = false
          if (this.new_password.length < 8) {
            this.error.new_password_length = true
          } else {
            this.error.new_password_length = false
          }
        }

        if (this.confirm_new_password === '') {
          this.error.confirm_new_password = true
          this.post = false
        } else {
          this.error.confirm_new_password = false
          if (this.confirm_new_password.length < 8) {
            this.error.confirm_new_password_length = true
          } else {
            this.error.confirm_new_password_length = false
          }
        }

        if (this.new_password !== this.confirm_new_password) {
          this.error.confirm_new_password_mismatch = true
          this.post = false
        } else {
          this.error.confirm_new_password_mismatch = false
        }

        if (this.post) {
          this.$refs.loading.load()

          let data = {
            token: this.$route.params.token,
            new_password: this.new_password
          }

          let that = this

          AuthenticationService.setpassword(data).then(res => {
            if (res.data.data === true) {
              that.$refs.loading.close()
              that.success = true
            }

            if (res.data.data === false) {
              that.$router.push('/login')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    submit() {
      this.post = true
      this.error.current_password_error = false

      if (this.new_password === '') {
        this.error.new_password = true
        this.post = false
      } else {
        this.error.new_password = false
        if (this.new_password.length < 8) {
          this.error.new_password_length = true
        } else {
          this.error.new_password_length = false
        }
      }

      if (this.confirm_new_password === '') {
        this.error.confirm_new_password = true
        this.post = false
      } else {
        this.error.confirm_new_password = false
        if (this.confirm_new_password.length < 8) {
          this.error.confirm_new_password_length = true
        } else {
          this.error.confirm_new_password_length = false
        }
      }

      if (this.new_password !== this.confirm_new_password) {
        this.error.confirm_new_password_mismatch = true
        this.post = false
      } else {
        this.error.confirm_new_password_mismatch = false
      }

      if (this.post) {
        this.$refs.loading.load()

        let data = {
          token: this.$route.params.token,
          new_password: this.new_password
        }

        let that = this

        AuthenticationService.setpassword(data).then(res => {
          if (res.data.data === true) {
            that.$refs.loading.close()
            that.success = true
          }

          if (res.data.data === false) {
            that.$router.push('/login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  mounted() {
    let that = this
    this.$refs.loading.load()
    AuthenticationService.check_password_link({ token: this.$route.params.token }).then((response) => {
      if (response.data.found) {
        that.$refs.loading.close()
        that.firstname = response.data.firstname
        that.lastname = response.data.lastname
        that.question = response.data.question
        that.broken = false
      } else {
        that.$refs.loading.close()
        that.broken = true
      }
    }).catch((error) => {
      return console.log(error)
    })
  }
}
</script>
